import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { schedulePropTypes } from 'constants/propTypes';

import messages from './ScheduleDetailV2.messages';
import StatsCard, { statsCardElement as element } from './StatsCard';

const EMPTY_BOOKINGS_COUNT = 0;

const AllBookingsStatCard = ({ schedule }) => {
  const { spots } = schedule;
  const { maxCapacity = EMPTY_BOOKINGS_COUNT, totalBooked = EMPTY_BOOKINGS_COUNT } = spots || {};

  return (
    <StatsCard
      dataCypress="booking-overview-all-bookings-card"
      label={<Message message={messages.allBookingsLabel} />}
      value={
        <Message
          message={messages.bookingsFraction}
          values={{
            muted: text => <span className={element('value-muted')}>{text}</span>,
            span: text => <span>{text}</span>,
            x: totalBooked,
            y: maxCapacity,
          }}
        />
      }
    />
  );
};

AllBookingsStatCard.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes).isRequired,
};

export default AllBookingsStatCard;
